/*
 * Scandalous Flawless: foundation script (deferred).
 * Scroll reveal driven by data attributes:
 *   data-sc-reveal="fade-up|fade|zoom"   reveal this element once when it scrolls into view
 *   data-sc-reveal-delay="200"           extra delay in ms
 *   data-sc-reveal-stagger               reveal the direct children one after another
 * Content is visible without JS, under prefers-reduced-motion and in the theme editor; the CSS only
 * hides elements while html.sc-js is present.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var REVEAL = '[data-sc-reveal]';
  var STAGGER = '[data-sc-reveal-stagger]';
  var STAGGER_STEP_MS = 80;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  // The head already adds sc-js (to avoid a flash of visible content). If its safety timer fired
  // before this file arrived, everything is visible and there is nothing left to animate.
  var disabled = window.__scRevealOff === true || reduceMotion || !('IntersectionObserver' in window);

  window.scTheme = window.scTheme || {};

  function reveal(el) {
    el.classList.add('is-revealed');
  }

  function prepare(el) {
    var delay = parseInt(el.getAttribute('data-sc-reveal-delay'), 10);
    if (!isNaN(delay) && delay > 0) {
      el.style.setProperty('--sc-delay', delay + 'ms');
    }
    if (el.hasAttribute('data-sc-reveal-stagger')) {
      var kids = el.children;
      for (var i = 0; i < kids.length; i++) {
        kids[i].style.setProperty('--sc-i', i);
      }
    }
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      // Very tall elements may never reach 15% of their own height; accept 15% of the viewport.
      var enough =
        entry.intersectionRatio >= 0.15 ||
        entry.intersectionRect.height >= window.innerHeight * 0.15;
      if (!enough) return;
      reveal(entry.target);
      observer.unobserve(entry.target);
    });
  }

  function init(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    var nodes = Array.prototype.slice.call(ctx.querySelectorAll(REVEAL + ',' + STAGGER));
    if (ctx !== document && ctx.matches && ctx.matches(REVEAL + ',' + STAGGER)) nodes.unshift(ctx);

    if (disabled) {
      nodes.forEach(reveal);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(onIntersect, { threshold: [0, 0.15] });
    }
    nodes.forEach(function (el) {
      if (el.classList.contains('is-revealed')) return;
      prepare(el);
      observer.observe(el);
    });
  }

  window.scTheme.initReveal = init;

  if (!disabled) {
    root.classList.add('sc-js');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Sections re-rendered by the theme editor or by the Section Rendering API.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
